import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

// Páginas públicas
import Home from './pages/Home';
import Properties from './pages/Properties';
import PropertyDetail from './pages/PropertyDetail';
import Contact from './pages/Contact';

// Panel Admin (directorio oculto /admin12)
import AdminLogin from './pages/admin12/AdminLogin';
import AdminDashboard from './pages/admin12/AdminDashboard';
import AdminProperties from './pages/admin12/AdminProperties';
import AdminPropertyForm from './pages/admin12/AdminPropertyForm';
import AdminMessages from './pages/admin12/AdminMessages';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <Routes>
          {/* Rutas públicas */}
          <Route path="/" element={<Home />} />
          <Route path="/propiedades" element={<Properties />} />
          <Route path="/propiedades/:id" element={<PropertyDetail />} />
          <Route path="/contacto" element={<Contact />} />

          {/* Panel Administración — directorio oculto */}
          <Route path="/admin12" element={<AdminLogin />} />
          <Route path="/admin12/dashboard" element={
            <ProtectedRoute><AdminDashboard /></ProtectedRoute>
          } />
          <Route path="/admin12/propiedades" element={
            <ProtectedRoute><AdminProperties /></ProtectedRoute>
          } />
          <Route path="/admin12/propiedades/nueva" element={
            <ProtectedRoute><AdminPropertyForm /></ProtectedRoute>
          } />
          <Route path="/admin12/propiedades/editar/:id" element={
            <ProtectedRoute><AdminPropertyForm /></ProtectedRoute>
          } />
          <Route path="/admin12/mensajes" element={
            <ProtectedRoute><AdminMessages /></ProtectedRoute>
          } />

          {/* Redirección por defecto */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
